import { createReducer, on, Action } from '@ngrx/store';
import { IOrganization } from '../../../models/organization';
import * as OrganizationActions from '../actions/index';

const initialState: OrganizationState = {
  organizationList: [],
  currentActiveFilter: true,
};

export interface OrganizationState {
  organizationList: IOrganization[];
  currentActiveFilter?: boolean;
}

const organizationState = createReducer(
  initialState,
  on(OrganizationActions.OrganizationUiActions.GetOrganizations, (state, { active }) => {
    return {
      ...state,
      currentActiveFilter: active !== undefined ? active : state.currentActiveFilter,
    };
  }),

  on(OrganizationActions.OrganizationApiActions.GetOrganizationListSuccess, (state, { payload }) => {
    return {
      ...state,
      organizationList: payload,
    };
  }),

  on(OrganizationActions.OrganizationApiActions.GetOrganizationListFailure, (state) => {
    return {
      ...state,
    };
  }),

  on(OrganizationActions.OrganizationApiActions.CreateOrganizationSuccess, (state, { payload }) => {
    return {
      ...state,
      organizationList: [...state.organizationList, payload],
    };
  }),

  on(OrganizationActions.OrganizationApiActions.UpdateOrganizationSuccess, (state, { payload }) => {
    return {
      ...state,
      organizationList: state.organizationList.map((org) => (org.id === payload.id ? payload : org)),
    };
  }),

  on(OrganizationActions.OrganizationApiActions.PatchOrganizationSuccess, (state, { payload }) => {
    return {
      ...state,
      organizationList: state.organizationList.map((org) => (org.id === payload.id ? payload : org)),
    };
  }),

  on(OrganizationActions.OrganizationApiActions.DeleteOrganizationSuccess, (state, { id }) => {
    return {
      ...state,
      organizationList: state.organizationList.filter((org) => org.id !== id),
    };
  })
);

export function OrganizationReducer(state: OrganizationState = initialState, action: Action): OrganizationState {
  return organizationState(state, action);
}
